import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    itemsAvailable: [],
    idNotification: "",
    url: "",
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    },
    getIdNotification(state) {
      return state.idNotification;
    },
    getUrl(state) {
      return state.url;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setIdNotification(state, value) {
      state.idNotification = value;
    },
    setUrl(state, value) {
      state.url = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/user-group-selection-option", {
        params,
        responseType: params?.action === "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }

      if (params?.action === "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const link = document.createElement("a");

        link.href = url;

        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );

        document.body.appendChild(link);

        link.click();

        link.remove();

        commit(
          "setIdNotification",
          response.headers["content-disposition"].split("filename=")[1]
        );

        commit("setUrl", url);
      } else {
        commit("setData", response.data.data);

        return response.data;
      }
    },
    async getGroupsAdmin({ commit }, params = {}) {
      const response = await axios.get("v1/user-group-selection-option/groups", {
        params,
      });

      const responseData = response.data;

      let items = [];

      if (Array.isArray(responseData?.data)) {
        items = responseData.data;
      } else if (Array.isArray(responseData?.data?.data)) {
        items = responseData.data.data;
      }

      commit("setData", items);

      return responseData;
    },
    async bulkUpdate(_, params) {
      const { data } = await axios.post(
        "v1/user-group-selection-option/bulk-update",
        params
      );

      return data;
    },
    async getGroupUsers(_, params) {
      const { data } = await axios.get("v1/user-group-selection-option/groups/users", {
        params,
      });

      return data;
    },
    async getHistory({ commit }, params) {
      const response = await axios.get("v1/user-group-selection-option/history", {
        params,
        responseType: params?.action === "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }

      if (params?.action === "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        commit(
          "setIdNotification",
          response.headers["content-disposition"].split("filename=")[1]
        );
        commit("setUrl", url);
      } else {
        commit("setData", response.data.data);

        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/user-group-selection-option", params);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/user-group-selection-option/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/user-group-selection-option/${id}`);

      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
